import { usePage } from "@inertiajs/react"
import type { SharedProps } from "@/types"

export function usePageProps<
  T extends Record<string, unknown> = Record<string, never>,
>(): SharedProps & T {
  return usePage().props as unknown as SharedProps & T
}
